<template>
  <div class="club-dashboard">
    <dashboard-charts :setLoading="setLoading" />
    <LoadingOverlay :loading="isLoading"  />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import DashboardCharts from '@/views/Dashboard/DashboardCharts.vue'
import LoadingOverlay from '../../../components/LoadingOverlay.vue';

export default {
  name: "ClubDashboard",
  components: {DashboardCharts, LoadingOverlay},
  data() {
    return {
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      overlayAddPost: false,
      overlayDeletePost: false,
      currentPost: null,
      isLoading: false
    };
  },
  mounted() {
    this.init();
  },
  watch: {
  },
  methods: {
    ...mapMutations(['setClubPosts']),
    linkify(inputText) {
      let replacedText, replacePattern1, replacePattern2;

      //URLs starting with http://, https://, or ftp://
      // eslint-disable-next-line no-useless-escape
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      // eslint-disable-next-line no-useless-escape
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
      return replacedText;
    },
    deletePost(post) {
      this.currentPost = post;
      this.overlayDeletePost = true;
    },
    setLoading(value){
      this.isLoading = value;
    }
  },
}
</script>



<style scoped>
  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
  .club-dashboard {
    padding: 1rem;
  }
</style>
